import { FormPanel } from "../../../../modules/content/components/FormPanel/FormPanel";
import { DaylightCommonContent } from "../../../../modules/content/components/DaylightCommonContent/DaylightCommonContent";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import type { IFormBlockProps } from "./FormBlock.props";

export const FormBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  errorMessage,
  eyebrow,
  fields,
  heading,
  parentClass,
  spacing,
  submitLabel,
  successMessage,
}: IFormBlockProps) => {
  if (!fields?.length) return null;
  return (
    <DaylightSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="grid gap-10 border-t border-border pt-10 lg:grid-cols-12 lg:gap-6 lg:pt-16">
        <DaylightCommonContent
          alignment={alignment}
          buttons={buttons}
          className="lg:col-span-4"
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className="lg:col-span-7 lg:col-start-6 lg:border-l lg:border-border lg:pl-10">
          <FormPanel
            errorMessage={errorMessage}
            fields={fields}
            submitLabel={submitLabel}
            successMessage={successMessage}
          />
        </div>
      </div>
    </DaylightSection>
  );
};

FormBlock.displayName = "Block::FormBlock";
